import React, {FC} from 'react';
import styled from 'styled-components';

import {DarkSidebarThemeProvider} from '../../../../libs/shared/ui/src/theme/darkSidebarThemeProvider';
import {ExpandedDarkThemeProvider} from '../../../../libs/shared/ui/src/theme/expandedDarkThemeProvider';

/*
 * Props.
 */

interface BottomBarProps {
  renderActionButtons: () => React.ReactNode;
  renderText: () => React.ReactNode;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  grid-area: bottom-bar;

  border-top: 2px solid ${(p) => p.theme.appBackground};
  background-color: ${(p) => p.theme.leftBar.background};

  padding: 10px 16px;
  display: flex;
  overflow: hidden;
  align-items: center;
  gap: 16px;
`;

const StyledActionsDiv = styled.div`
  display: flex;
  overflow: hidden;
  gap: 8px;
`;

/*
 * Component.
 */

export const BottomBar: FC<BottomBarProps> = (props) => {
  const {renderActionButtons, renderText} = props;

  return (
    <ExpandedDarkThemeProvider>
      <DarkSidebarThemeProvider>
        <StyledDiv>
          {renderText()}
          <StyledActionsDiv>{renderActionButtons()}</StyledActionsDiv>
        </StyledDiv>
      </DarkSidebarThemeProvider>
    </ExpandedDarkThemeProvider>
  );
};
